// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__322j7","author":"Table_author__1q8HV","authorImage":"Table_authorImage__3Qn5z","unreadRow":"Table_unreadRow__2yqay"};